<template>
  <ValidationProvider
      tag="div" :class="inline && 'd-flex flex-row'"
      :name="labelText" :rules="getRules()"
      v-slot="{ errors }">
    <label v-if="!inline && !hideLabel" :for="getId()">{{ capitalize(labelText) }}</label>
    <input
        type="text" :class="getInputFieldClass()"
        :id="getId()" :placeholder="'Voer ' + labelText + ' in'"
        :minlength="minLength" :maxlength="maxLength"
        v-model="inputVal"/>

    <div v-if="inline" class="pl-3 col-lg-8">
      <span class="text-red">{{ errors[0] }}</span>
    </div>
    <span v-else class="text-red">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  name: "TextInputField",
  components: {
    ValidationProvider
  },
  props: {
    value: String,
    labelText: String,
    hideLabel: Boolean,
    inline: Boolean,
    required: Boolean,
    email: Boolean,
    minLength: String,
    maxLength: String,
    id: String,
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    getId() {
      return this.id || this.labelText;
    },
    capitalize(value) {
      if (!value) {
        return "";
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    getRules() {
      const rules = [];

      if (this.required) {
        rules.push("required");
      }
      if (this.email) {
        rules.push("email");
      }
      if (this.minLength) {
        rules.push("min:" + this.minLength);
      }
      if (this.maxLength) {
        rules.push("max:" + this.maxLength);
      }

      return rules.join('|');
    },
    getInputFieldClass() {
      return this.inline ? "form-control col-lg-4" : "form-control";
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>